module.exports = __webpack_public_path__ + "media/images/pages/solutions/services-534c0a66a3e4c4d9297646d2494cc8cd.svg";